import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { BRAND_DICTIONARY, BrandTheme } from './brand.config';

@Injectable({
  providedIn: 'root',
})
export class BrandService {
  private currentBrandSubject = new BehaviorSubject<BrandTheme>(
    BRAND_DICTIONARY['localhost'],
  );
  public currentBrand$ = this.currentBrandSubject.asObservable();

  constructor(@Inject(DOCUMENT) private document: Document) {}

  public initTheme(simulatedDomain?: string): void {
    let targetDomain: string;

    if (simulatedDomain) {
      localStorage.setItem('dev_simulated_domain', simulatedDomain);
      targetDomain = simulatedDomain;
    } else {

      targetDomain =
        localStorage.getItem('dev_simulated_domain') ||
        window.location.hostname;
    }

    const brandTheme =
      BRAND_DICTIONARY[targetDomain] || BRAND_DICTIONARY['localhost'];

    this.currentBrandSubject.next(brandTheme);

    const root = this.document.documentElement;
    root.style.setProperty('--brand-primary', brandTheme.primaryColor);
    root.style.setProperty('--brand-secondary', brandTheme.secondaryColor);
    root.style.setProperty('--brand-button', brandTheme.buttonColor);

   
  }

  public get theme(): BrandTheme {
    return this.currentBrandSubject.value;
  }
}
